import React, { memo } from 'react'

interface ShareScreenIconProps {
  size?: number
}

const ShareScreenIcon: React.FC<ShareScreenIconProps> = memo(
  ({ size = 16 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M2.4 1.55556C2.18783 1.55556 1.98434 1.6375 1.83431 1.78336C1.68429 1.92922 1.6 2.12705 1.6 2.33333V9.33333C1.6 9.53961 1.68429 9.73744 1.83431 9.88331C1.98434 10.0292 2.18783 10.1111 2.4 10.1111H13.6C13.8122 10.1111 14.0157 10.0292 14.1657 9.88331C14.3157 9.73744 14.4 9.53961 14.4 9.33333V2.33333C14.4 2.12705 14.3157 1.92922 14.1657 1.78336C14.0157 1.6375 13.8122 1.55556 13.6 1.55556H2.4ZM2.4 0H13.6C14.2365 0 14.847 0.245833 15.2971 0.683417C15.7471 1.121 16 1.71449 16 2.33333V9.33333C16 9.95217 15.7471 10.5457 15.2971 10.9832C14.847 11.4208 14.2365 11.6667 13.6 11.6667H2.4C1.76348 11.6667 1.15303 11.4208 0.702944 10.9832C0.252856 10.5457 0 9.95217 0 9.33333L0 2.33333C0 1.71449 0.252856 1.121 0.702944 0.683417C1.15303 0.245833 1.76348 0 2.4 0ZM5.6 12.4444H10.4C10.6122 12.4444 10.8157 12.5264 10.9657 12.6722C11.1157 12.8181 11.2 13.0159 11.2 13.2222C11.2 13.4285 11.1157 13.6263 10.9657 13.7722C10.8157 13.9181 10.6122 14 10.4 14H5.6C5.38783 14 5.18434 13.9181 5.03431 13.7722C4.88429 13.6263 4.8 13.4285 4.8 13.2222C4.8 13.0159 4.88429 12.8181 5.03431 12.6722C5.18434 12.5264 5.38783 12.4444 5.6 12.4444Z"
        fill="currentColor"
      />
    </svg>
  ),
)

export { ShareScreenIcon }
